import React from 'react';
import { ListItemText, MenuItem, Select } from '@mui/material';
import { usePipelineContext } from '@/context/pipelineContext';

export const DealStageSelect = ({
	pipeline,
	stage,
	onChange,
	disabled,
	disableClosedStages = false,
}) => {
	const { stages, isLoading } = usePipelineContext(pipeline);

	return (
		<Select
			fullWidth
			displayEmpty
			disabled={disabled || isLoading}
			value={stage?.id ?? ''}
			onChange={(event) => {
				const newStage = stages.find((s) => s.id === event.target.value);
				onChange(newStage ?? null);
			}}
			sx={{
				display: 'flex',
				maxHeight: 53,
				alignItems: 'center',
			}}
			MenuProps={{
				anchorOrigin: {
					vertical: 'bottom',
					horizontal: 'left',
				},
				transformOrigin: {
					vertical: 'top',
					horizontal: 'left',
				},
				marginThreshold: 0,
				PaperProps: {
					sx: { maxHeight: 280 },
				},
			}}
		>
			{stages.map((option) => (
				<MenuItem
					key={`deal-stage-${option.id}`}
					value={option.id}
					disabled={disableClosedStages && (option.completed || option.closed)}
				>
					<ListItemText primary={option.label} />
				</MenuItem>
			))}
		</Select>
	);
};
